export const TABLE_PAGINATION_KEY = "tablePagination";

//constant for the status data
export const DATA_STATUS = {
    ACTIVE : "active",
    INACTIVE: "inactive"
}